export type FFPermissionMap = Record<number, server.dto.FreeFieldPermissionLevels>;

export const getFreefieldPermissionMap = (permissions: server.dto.FreeFieldDefinitionPermission[]): FFPermissionMap => permissions.reduce((acc, curr) => ({
  ...acc,
  [curr.freeFieldDefinitionId]: curr.level
}), {});